"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("circle", { cx: "23.8", cy: "12.6", r: "2.5" }),
  React.createElement("path", { d: "M34.875 4H1.125A1.068 1.068 0 0 0 0 5v22a1.068 1.068 0 0 0 1.125 1h2.4a13.207 13.207 0 0 1 3.24-1.088 11.566 11.566 0 0 1-2.131-6.469c0-.046.01-.086.01-.131C3.152 22.2 2 24 2 24V6h32v16a15.167 15.167 0 0 0-6.182-2c-2.463 0-4.648 2.785-7.02 3.695a11.673 11.673 0 0 1-1.55 3.242A13.632 13.632 0 0 1 22.383 28h12.492A1.068 1.068 0 0 0 36 27V5a1.068 1.068 0 0 0-1.125-1z" }),
  React.createElement("path", { d: "M24 34.038a3.119 3.119 0 0 0-1.048-2.353 10.113 10.113 0 0 0-5.738-2.234 1.144 1.144 0 0 1-.99-1.148v-1.658a1.113 1.113 0 0 1 .276-.722 8.748 8.748 0 0 0 2.006-5.48C18.507 16.31 16.315 14 13 14s-5.567 2.4-5.567 6.443a8.852 8.852 0 0 0 2.107 5.485 1.1 1.1 0 0 1 .273.718V28.3a1.138 1.138 0 0 1-.993 1.149 9.692 9.692 0 0 0-5.809 2.232A3.126 3.126 0 0 0 2 34v2h22z" })
);

